
import ProblemKendaraanTradoMain from "../../../features/problem/problem-kendaraan-trado/component/ProblemKendaraanTradoMain";

const ProblemKendaraanTradoPage = () => {
  return <ProblemKendaraanTradoMain />;
};

export default ProblemKendaraanTradoPage;
